var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1659 1.66356C9.47086 0.913212 8.50016 0.5 7.42873 0.5C6.3516 0.5 5.37767 0.910712 4.68589 1.65642C3.98661 2.41035 3.6459 3.43498 3.7259 4.5414C3.88447 6.72425 5.54553 8.49995 7.42873 8.49995C9.31194 8.49995 10.9701 6.72461 11.1312 4.54212C11.2123 3.4457 10.8694 2.4232 10.1659 1.66356ZM13.7144 16.4999H1.14305C0.978507 16.502 0.815552 16.4675 0.666045 16.3987C0.516537 16.33 0.384239 16.2287 0.278774 16.1024C0.0466326 15.8249 -0.0469383 15.446 0.022347 15.0628C0.323774 13.3906 1.26448 11.986 2.74305 10.9999C4.05661 10.1246 5.72053 9.6428 7.42873 9.6428C9.13694 9.6428 10.8009 10.1249 12.1144 10.9999C13.593 11.9856 14.5337 13.3903 14.8351 15.0624C14.9044 15.4456 14.8108 15.8246 14.5787 16.102C14.4733 16.2284 14.341 16.3297 14.1915 16.3986C14.042 16.4674 13.879 16.502 13.7144 16.4999Z",
    fill: "#18A0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.a9e493f19e31cdf0ba940df596fa5a54.svg";
export { ForwardRef as ReactComponent };